import classNames from "classnames";

interface ShimmerProps {
  className?: string;
}

export function Shimmer({ className }: ShimmerProps) {
  return (
    <div className={classNames("absolute inset-0 pointer-events-none overflow-hidden", className)} aria-hidden>
      <div className="absolute top-0 left-0 h-full w-[40%] bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,0.08)_50%,transparent_100%)] animate-shimmersweep" />
    </div>
  );
}
